import { tokens } from "../../tokens";

/**
 * MuiTextField – use theme.palette so light/dark mode work.
 * Prefer slotProps for instance-level tweaks.
 */
export const MuiTextFieldOverrides = {
  defaultProps: {
    variant: "outlined",
    size: "medium",
  },
  styleOverrides: ({ theme }) => ({
    root: {
      "& .MuiOutlinedInput-root": {
        borderRadius: tokens.radius.md,
        "& fieldset": {
          borderColor: theme.palette.divider,
        },
        "&:hover fieldset": {
          borderColor: theme.palette.text.secondary,
        },
        "&.Mui-focused fieldset": {
          borderWidth: 1,
          borderColor: theme.palette.primary.main,
          boxShadow: `0 0 0 2px ${theme.palette.primary.light}`,
        },
        "&.Mui-error fieldset": {
          borderColor: theme.palette.error.main,
        },
      },
    },
  }),
};
